// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  //DEV
  BackendUrl: "https://api-dev.cdoc.se/rest",
  loginReroute: "http://test.cdoc.se/#/login",
  buildVersion: '2e08f65a' // CI will fill this (e.g. commit SHA or date)
};


